////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const rolesManager = {
	getPerimeters: () => ({
		type: ActionsTypes.GET_PERIMETERS,
	}),
	getPerimetersSuccess: (perimeters) => ({
		type: ActionsTypes.GET_PERIMETERS_SUCCESS,
		payload: {
			perimeters,
		},
	}),
	getPerimetersFailure: (error) => ({
		type: ActionsTypes.GET_PERIMETERS_FAILURE,
		payload: {
			error,
		},
	}),
	getPerimeter: (idPerimeter) => ({
		type: ActionsTypes.GET_PERIMETER,
		payload: { idPerimeter },
	}),
	getPerimeterSuccess: (perimeter) => ({
		type: ActionsTypes.GET_PERIMETER_SUCCESS,
		payload: {
			perimeter,
		},
	}),
	getPerimeterFailure: (error) => ({
		type: ActionsTypes.GET_PERIMETER_FAILURE,
		payload: {
			error,
		},
	}),
	getKiosksWithCriteria: (datas, mode) => ({
		type: ActionsTypes.GET_KIOSKS_WITH_CRITERIA,
		payload: { datas, mode },
	}),
	getKiosksWithCriteriaSuccess: (kiosks) => ({
		type: ActionsTypes.GET_KIOSKS_WITH_CRITERIA_SUCCESS,
		payload: {
			kiosks,
		},
	}),
	getKiosksWithCriteriaFailure: (error) => ({
		type: ActionsTypes.GET_KIOSKS_WITH_CRITERIA_FAILURE,
		payload: {
			error,
		},
	}),
	getListTags: () => ({
		type: ActionsTypes.GET_LIST_TAGS,
	}),
	getListTagsSuccess: (tags) => ({
		type: ActionsTypes.GET_LIST_TAGS_SUCCESS,
		payload: {
			tags,
		},
	}),
	getListTagsFailure: (error) => ({
		type: ActionsTypes.GET_LIST_TAGS_FAILURE,
		payload: {
			error,
		},
	}),
	resetKiosksScope: () => ({
		type: ActionsTypes.RESET_KIOSKS_SCOPE,
	}),
	createPerimeter: (perimeter) => ({
		type: ActionsTypes.CREATE_PERIMETER,
		payload: {
			perimeter,
		},
	}),
	createPerimeterSuccess: (perimeter) => ({
		type: ActionsTypes.CREATE_PERIMETER_SUCCESS,
		payload: {
			perimeter,
		},
	}),
	createPerimeterFailure: (error) => ({
		type: ActionsTypes.CREATE_PERIMETER_FAILURE,
		payload: {
			error,
		},
	}),
	applyPerimeter: (perimeter, idPerimeter) => ({
		type: ActionsTypes.APPLY_PERIMETER,
		payload: {
			perimeter,
			idPerimeter,
		},
	}),
	updatePerimeter: (perimeter, idPerimeter) => ({
		type: ActionsTypes.UPDATE_PERIMETER,
		payload: {
			perimeter,
			idPerimeter,
		},
	}),
	updatePerimeterSuccess: (perimeter, idPerimeter) => ({
		type: ActionsTypes.UPDATE_PERIMETER_SUCCESS,
		payload: {
			perimeter,
			idPerimeter,
		},
	}),
	updatePerimeterFailure: (error) => ({
		type: ActionsTypes.UPDATE_PERIMETER_FAILURE,
		payload: {
			error,
		},
	}),
	deletePerimeter: (idPerimeter) => ({
		type: ActionsTypes.DELETE_PERIMETER,
		payload: {
			idPerimeter,
		},
	}),
	deletePerimeterSuccess: (idPerimeter) => ({
		type: ActionsTypes.DELETE_PERIMETER_SUCCESS,
		payload: {
			idPerimeter,
		},
	}),
	deletePerimeterFailure: (error) => ({
		type: ActionsTypes.DELETE_PERIMETER_FAILURE,
		payload: {
			error,
		},
	}),
}

export default rolesManager
